import orderAPI from '@/api/order'

export default {
  state: {
    orderList: null,
    orderData: {},
    orderProductList: [],
    orderStatusHistoryList: [],
    isUserHasOrder: false
  },
  getters: {
    getOrderList (state) {
      return state.orderList
    },
    getOrderData (state) {
      return state.orderData
    },
    getOrderProductList (state) {
      return state.orderProductList
    },
    getOrderStatusHistoryList (state) {
      return state.orderStatusHistoryList
    },
    getIsUserHasOrder (state) {
      return state.isUserHasOrder
    }
  },
  mutations: {
    setOrderList (state, value) {
      state.orderList = value
    },
    setOrderData (state, value) {
      state.orderData = value
    },
    setOrderProductList (state, value) {
      state.orderProductList = value
    },
    setOrderStatusHistoryList (state, value) {
      state.orderStatusHistoryList = value
    },
    setIsUserHasOrder (state, value) {
      state.isUserHasOrder = value
    },
    resetOrderList (state) {
      state.orderList = null
      state.isUserHasOrder = false
    },
    resetState (state) {
      const initialState = {
        orderList: null,
        orderData: {},
        orderProductList: [],
        orderStatusHistoryList: [],
        isUserHasOrder: false
      }
      Object.assign(state, initialState)
    }
  },
  actions: {
    GET_ORDER_LIST ({ commit, state }, { payload, success, fail }) {
      orderAPI.getOrderList(payload).then(response => {
        if (response.body.success) {
          const responseValue = response.body.value
          const currentResponse = responseValue.quotationHistoryList || []
          commit('setIsUserHasOrder', responseValue.hasOrders)
          const orderList = state.orderList ? state.orderList.concat(currentResponse) : currentResponse
          commit('setOrderList', orderList)
          success && success(responseValue.pageMetaData)
        } else {
          if (!state.orderList) {
            commit('setOrderList', [])
          }
          fail && fail()
        }
      }).catch(() => {
        if (!state.orderList) {
          commit('setOrderList', [])
        }
        fail && fail()
      })
    },
    GET_ORDER_DETAIL ({ commit }, { query, success, fail }) {
      orderAPI.getOrderDetail(query).then(res => {
        commit('setOrderData', res.body.value.quotationResponse)
        commit('setOrderProductList', res.body.value.quotationProductsList)
        commit('setOrderStatusHistoryList', res.body.value.statusHistoryList)
        success && success(res.body)
      }).catch(err => {
        fail && fail(err)
      })
    },
    PROCESS_QUOTATION (_, { data, success, fail }) {
      orderAPI.processQuotation(data).then(res => {
        if (res.body.success) {
          success && success(res.body)
        } else {
          fail && fail(res.body)
        }
      }).catch(err => {
        fail && fail(err)
      })
    },
    CREATE_OTP (_, { data, success, fail }) {
      orderAPI.createOtp(data).then(res => {
        if (res.body.success) {
          success && success(res.body)
        } else {
          fail && fail(res.body)
        }
      }).catch(err => {
        fail && fail(err)
      })
    },
    VALIDATE_OTP ({ commit }, { data, success, fail }) {
      orderAPI.validateOtp(data).then(res => {
        if (res.body.success) {
          success && success(res.body.value)
          const feedbackResponse = res.body.value?.feedbackResponse
          setTimeout(() => {
            commit('npsStore/setShowNpsPopup', feedbackResponse?.triggerFeedback, { root: true })
            commit('npsStore/setFeedbackId', feedbackResponse?.feedBackId || null, { root: true })
          }, 500)
        } else {
          fail && fail(res.body)
        }
      }).catch(err => {
        fail && fail(err)
      })
    }
  },
  namespaced: true
}
